import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/services/auth.service';

export type UserManual = {
  _id?: string;
  title: string;
  version: string;
  size: string;
  date: string;
  language: string;
  link: string;
  keywords: string[];
  type: string;
};

type UserManualResponse = {
  success: boolean;
  data: UserManual[];
};

@Injectable({
  providedIn: 'root',
})
export class UserManualService {
  constructor(private readonly http: HttpClient, private readonly auth: AuthService) {}

  getUserManuals() {
    return this.http.get<UserManualResponse>(`${environment.webappEndpoint}/userManual`, {
      headers: { Authorization: `Bearer ${this.auth.getToken()}` },
    });
  }

  downloadUserManual(id: string) {
    return this.http.get(`${environment.webappEndpoint}/userManual/${id}`, {
      headers: { Authorization: `Bearer ${this.auth.getToken()}` },
      responseType: 'blob',
    });
  }
}
